import React, { useEffect, useState } from "react";

import "./footer.css";

const Footer = () => {
  const [showFooter, setShowFooter] = useState(false);

  useEffect(() => {
    const hideParam = new URL(document.location.href).searchParams.get(
      "hide-footer"
    );
    setShowFooter(hideParam ? false : true);
  }, []);

  return (
    <>
      {showFooter && (
        <footer className="footer">
          <div
            className="container"
            style={{ borderTop: "2px solid #fff", paddingTop: "4rem" }}
          >
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="footer-call-us">
                  Call Us <a href="tel:6307487515">630.748.7515</a>
                </div>
                <div className="footer-links">
                  <a
                    href="https://neighborhoodloans.com/privacy-policy/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Privacy Policy
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://neighborhoodloans.com/licensing/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Licensing
                  </a>{" "}
                  |{" "}
                  <a
                    href="http://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/222982"
                    target="_blank"
                    rel="noreferrer"
                  >
                    NMLS Consumer Access
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://www.idfpr.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    IDFPR
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://neighborhoodloans.com/tracking-footer-agreement/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Tracking Cookie Agreement
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://neighborhoodloans.com/ca-privacy-policy/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    CA Privacy Policy
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://neighborhoodloans.com/neighborhood-loans-accessibility-statement/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Accessibility
                  </a>
                  <div>
                    For licensing information, go to:{" "}
                    <i>
                      <a
                        href="http://www.nmlsconsumeraccess.org"
                        target="_blank"
                        rel="noreferrer"
                      >
                        www.nmlsconsumeraccess.org
                      </a>
                    </i>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="text-right">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "/assets/images/accolades.png"
                    }
                    alt=""
                    style={{ maxWidth: "100%" }}
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="lender">
                  <div className="lender-img">
                    <img
                      src="./assets/images/lender.png"
                      alt=""
                      style={{ width: 100 }}
                    />
                  </div>
                  <div className="lender-text">
                    <p>
                      Neighborhood Loans, 1333 Butterfield Rd. Suite 600 Downers
                      Grove, IL 60515. 1.800.207.8595. Neighborhood Loans in an
                      Illinois, Wisconsin, and California Residential Mortgage
                      Licensee. Neighborhood Loans is an approved FHA Lending.
                      Not an agency of the federal government. All loans are
                      subject to credit approval. Programs, rates, terms, and
                      conditions are subject to change without notice. Other
                      restrictions apply. Licensed by the California Department
                      of Financial Protection and Innovation under the
                      California Residential Mortgage Lending Act. License
                      #41DBO-118971.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      )}
    </>
  );
};

export default Footer;
